import { render } from "./ImportProgressView.vue?vue&type=template&id=2dd7b8db"
import script from "./ImportProgressView.vue?vue&type=script&lang=js"
export * from "./ImportProgressView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__